import { formatHours } from '../../../helpers/timesheet'
import type { HoursByTask } from './types'

/** Per-task hour pills, colored by task (v1 TimeByActivity). */
export const TimeByActivity = ({
  hoursByTask,
}: {
  hoursByTask: HoursByTask[]
}) => {
  if (hoursByTask.length === 0) return null
  return (
    <div className='tc-operating-pills'>
      {hoursByTask.map((task) => (
        <span
          key={task.id}
          className='tc-operating-pill'
          style={{ borderColor: task.color, color: task.color }}
        >
          {task.name} <strong>{formatHours(task.minutes)}</strong>
        </span>
      ))}
    </div>
  )
}
